import { render, staticRenderFns } from "./NotifLikeMyComment.vue?vue&type=template&id=17496a38&scoped=true"
import script from "./NotifLikeMyComment.vue?vue&type=script&lang=js"
export * from "./NotifLikeMyComment.vue?vue&type=script&lang=js"
import style0 from "./NotifStyle.scss?vue&type=style&index=0&id=17496a38&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17496a38",
  null
  
)

export default component.exports